module.exports = __webpack_public_path__ + "static/elearning-fc5e41c799668d4bc951015dd6039c6c.png";